import { render, staticRenderFns } from "./ListPermission.vue?vue&type=template&id=095ab54c"
import script from "./ListPermission.vue?vue&type=script&lang=js"
export * from "./ListPermission.vue?vue&type=script&lang=js"
import style0 from "./ListPermission.vue?vue&type=style&index=0&id=095ab54c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports